// src/utils/noop.ts
var noop = (..._args) => {
};

export {
  noop
};
//# sourceMappingURL=chunk-7FNX7RWY.mjs.map